import Grid from "../../ui/Grid";

export default class SortItemsFromQuery extends Grid {
  constructor() {
    super();
    this.urlParams = new URLSearchParams(window.location.search);
    this.tag = this.urlParams.get('tag');
    if (!this.tag) return;
    this.$buttons = [...document.querySelectorAll('[data-category-target]')];
    this.$targets = [...document.querySelectorAll('[data-category-id]')]
    this.clone;
    this.init();
  }

  init() {
    this.$buttons.forEach(button => {
      const categoryTarget = button.dataset.categoryTarget;
      if (this.tag === categoryTarget) {
        button.classList.add(this.CLASSES.isSelected);
      }
    });

    this.clone = []

    this.$targets.forEach((item) => {
      this.clone.push(item);
      item.remove();
    });

    this.clone.forEach(item => {
      const categoryId = item.dataset.categoryId;
      const fadeTl = gsap.timeline({ defaults: { duration: 0.3, ease: 'none' }});
      fadeTl
        .to(this.$grid, {
          opacity: 0,
          onComplete: () => {
            this.show(item, this.tag, categoryId);
          }
        },)
        .to(this.$grid, {
          opacity: 1,
        }, '+=0.3')
    });
  }

  show(element, tag, categoryId) {
    if (tag === categoryId) {
      this.createItem(element)
    }
  }

  createItem(element) {
    this.$grid.appendChild(element);
    setTimeout(() => this.createGrid());
  }
}
